import React, { useState } from 'react';
import { API_BASE_URL } from '../../config';

function NextSteps({
  isOpen,
  onToggle,
  uuid,
  nextSteps,
  loadingNextSteps,
  nextStepsError,
  emailSaved,
  formData,
  onSaveEmail
}) {
  const [email, setEmail] = useState('');
  const [isSavingEmail, setIsSavingEmail] = useState(false);

  const handleSaveEmail = async (e) => {
    e.preventDefault();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert('Please enter a valid email address');
      return;
    }

    setIsSavingEmail(true);
    const success = await onSaveEmail(email);
    setIsSavingEmail(false);

    if (success) {
      alert('Email saved! You will receive a link to this report shortly.');
    } else {
      alert('Failed to save email. Please try again.');
    }
  };

  return (
    <section id="next-steps-section" className="report-section">
      <div className="section-header" onClick={onToggle}>
        <h2>
          Your Personalized Next Steps
          {nextSteps?.generated_at && (
            <span style={{
              fontSize: '0.7em',
              fontWeight: 'normal',
              marginLeft: '10px',
              color: '#6b7280'
            }}>
              (Generated {new Date(nextSteps.generated_at).toLocaleDateString()})
            </span>
          )}
        </h2>
        <button className="accordion-toggle">
          {isOpen ? '▼' : '▶'}
        </button>
      </div>

      {isOpen && (
        <div className="section-content">
          {/* Email Gate */}
          {!(emailSaved || formData?.contactEmail) ? (
            <div className="email-gate-container" style={{ textAlign: 'center', padding: '2rem' }}>
              <h3>Unlock Your Personalized Next Steps</h3>
              <p style={{ marginBottom: '1.5rem' }}>
                Get AI-powered personalized advice for your college journey.
                Enter your email to access your custom action plan and PDF report.
              </p>
              <form onSubmit={handleSaveEmail} style={{ maxWidth: '400px', margin: '0 auto' }}>
                <input
                  type="email"
                  placeholder="your.email@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="widget-input"
                  style={{ width: '100%', marginBottom: '1rem' }}
                  required
                />
                <button
                  type="submit"
                  className="action-button primary"
                  disabled={isSavingEmail}
                  style={{ width: '100%' }}
                >
                  {isSavingEmail ? 'Saving...' : 'Unlock Next Steps & Get PDF'}
                </button>
              </form>
            </div>
          ) : loadingNextSteps ? (
            <div className="loading-state">
              <p>Generating your personalized next steps...</p>
            </div>
          ) : nextStepsError ? (
            <div className="error-state">
              <p>{nextStepsError}</p>
            </div>
          ) : nextSteps ? (
            <div className="next-steps-container">
              {/* Profile Summary */}
              {nextSteps.profile_summary && (
                <div className="next-steps-summary">
                  <p>{
                    nextSteps.profile_summary
                      .replace(/^Next Steps:?\s*\n?/i, '')
                      .replace(/\n\s*Next Steps:?\s*\n?/gi, '\n')
                      .trim()
                  }</p>
                </div>
              )}


              {/* Action Items */}
              {nextSteps.next_steps && nextSteps.next_steps.length > 0 && (
                <div className="action-items">
                  <h3>Your Action Items</h3>
                  <div className="next-steps-grid">
                    {nextSteps.next_steps.map((step, index) => (
                      <div key={index} className={`next-step-card priority-${step.priority}`}>
                        <div className="step-header">
                          <h4>{step.title}</h4>
                          <span className={`priority-badge ${step.priority}`}>
                            {step.priority === 'high' ? '🔴 High Priority' :
                             step.priority === 'medium' ? '🟡 Medium Priority' :
                             '🟢 Low Priority'}
                          </span>
                        </div>
                        <p className="step-description">{step.description}</p>
                        <div className="step-timeline">
                          <span className="timeline-label">Timeline:</span>
                          <span className="timeline-value">{step.timeline}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Key Insights */}
              {nextSteps.key_insights && nextSteps.key_insights.length > 0 && (
                <div className="key-insights">
                  <h3>Key Insights</h3>
                  <ul>
                    {nextSteps.key_insights.map((insight, index) => (
                      <li key={index}>{insight}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Reflection Questions */}
              {nextSteps.reflection_questions && nextSteps.reflection_questions.length > 0 && (
                <div className="reflection-questions">
                  <h3>Questions for Reflection</h3>
                  <ul>
                    {nextSteps.reflection_questions.map((question, index) => (
                      <li key={index}>{question}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Download PDF Button */}
              {(emailSaved || formData?.contactEmail) && (
                <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                  <a
                    href={`${API_BASE_URL}/api/universities/reports/${uuid}/pdf/`}
                    download={`college-report-${uuid}.pdf`}
                    className="action-button primary"
                    style={{ display: 'inline-block' }}
                  >
                    Download PDF Report
                  </a>
                </div>
              )}
            </div>
          ) : (
            <div className="empty-state">
              <p>No personalized next steps available yet.</p>
            </div>
          )}
        </div>
      )}
    </section>
  );
}

export default NextSteps;